namespace RecordShield.Wallet {
    export interface CreditStatementRow {
        TransactionDate?: string;
        TransactionDetails?: string;
        TransactionId?: number;
        TransactionNo?: string;
        Withdrawal?: number;
        Deposit?: number;
        Credit?: number;
        Balance?: number;
    }

    export namespace CreditStatementRow {
        export const nameProperty = 'TransactionDetails';
        export const localTextPrefix = 'Wallet.CreditStatement';

        export namespace Fields {
            export declare const TransactionDate: string;
            export declare const TransactionDetails: string;
            export declare const TransactionId: string;
            export declare const TransactionNo: string;
            export declare const Withdrawal: string;
            export declare const Deposit: string;
            export declare const Credit: string;
            export declare const Balance: string;
        }

        ['TransactionDate', 'TransactionDetails', 'TransactionId', 'TransactionNo', 'Withdrawal', 'Deposit', 'Credit', 'Balance'].forEach(x => (<any>Fields)[x] = x);
    }
}
